import { createSlice } from "@reduxjs/toolkit";

export const healthSafetyReducer = createSlice({
  name: "healthSafety",
  initialState: [
    {
      id: "",

      // note: probably there will be a status for the report: [draft, pending, resolving, rejected, resolved, cancelled]

      description: "", // string: description of the report
      reportType: "", // TODO (Lenny: change the field name to reportType) type of hazard, incident or accident
      sendLocation: "", // object: with { latitude: 9.1234, longitude: 8.5789 }
      enterLocation: "", // object: with manual location properties { addressLine1: string, addressLine2: string, postcode: string, city: string, state: string, countryCode: string }
      reportedBy: "", // integer: reference to Employee | TODO: Employee lookup must be provided to forms
      // TODO (Lenny) add | reportedByOther: string
      dateOfObservation: "", // date: [YYYY-MM-DD hh:mm:ss]
      individualsAffected: "", // note: this seems to be a helper input to store data temporarily while not added to individualsList
      individualsList: [],
      /** individualsList:
       [
         {
           employee: integer | TODO: Employee lookup must be provided to forms
           name: string
           bodyPartsAffected : array [ "head", "neck", "shoulders", "leftArm", "rightArm", "leftLowerArm", "rightLowerArm", "leftHand", "rightHand", "upperBack", "lowerBack", "leftLeg", "rightLeg", "leftFoot", "rightFoot", "other" ]
         },
         ...
       ],
       **/

      /** TODO (Lenny) add | equipmentList: (only applicable to Accident Form)
       [
          {
            barcode: string
            type: integer | Reference to Equipment type | TODO: Equipment type lookup must be provided to forms
            name: string
            equipmentReference: string
            color: string
            description: string
          },
          ...
       ],
      **/

      /** TODO (Lenny) add | materialList: (only applicable to Accident Form)
       [
         {
           type: integer | Reference to Material type | TODO: Material type lookup must be provided to forms
           name: string
           idSQ: string
         },
         ...
       ],
      **/

      bodyAffected: "", // note: seems to be a temporary placeholder ???

      /** TODO (Lenny) add | severity [low: Low, moderate: Moderate, high: High, critical: Critical]: */
      risk: "", // note: only applicable to the manager (only applicable to Hazard and Incident Form)
      priority: "", // note: only applicable to the manager (only applicable to Hazard and Incident Form)

      action: "", // TODO (Lenny) see what this is being used for, and if we should store it in the backend
      attachedFile: [], // They will be submitted separately

      /** TODO (Lenny) add | additionalComments "TextArea": (right now is only applicable to Accident Form, see with Yahya if should be present in all forms) */

      // All these fields below seem to be helper fields, confirm
      nextHappen: "",
      type: "",
      otherType: "",
      date: "",
      otherReporter: "",
      firstLine: "",
      secondLine: "",
      province: "",
      postcode: "",
      status: "",
      isDraft: false,
    },
  ],
  reducers: {
    addHealthSafety: (state, action) => {
      state.push(action.payload);
    },
    removeHealthSafety: (state, action) => {
      return state.filter(
        (healthSafety) => healthSafety.id !== action.payload.id,
      );
    },
    updateHealthSafety: (state, action) => {
      const index = state.findIndex(
        (healthSafety) => healthSafety.id === action.payload.id,
      );
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
  },
});

export const { addHealthSafety, removeHealthSafety, updateHealthSafety } =
  healthSafetyReducer.actions;
export default healthSafetyReducer.reducer;
